function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M16.864 14.008L11.51 8.849l5.353-5.158c.167-.156.301-.343.394-.55l-.183-.082.183.082a1.653 1.653 0 00-.374-1.878 1.762 1.762 0 00-.577-.37 1.81 1.81 0 00-1.354.011 1.759 1.759 0 00-.569.378L9.02 6.45 3.655 1.282a1.76 1.76 0 00-.57-.378 1.808 1.808 0 00-1.93.359C.99 1.422.86 1.612.77 1.82a1.652 1.652 0 00.012 1.32 1.7 1.7 0 00.394.55L6.529 8.85l-5.353 5.159a1.7 1.7 0 00-.394.55 1.653 1.653 0 00.373 1.878c.165.16.362.285.577.37a1.81 1.81 0 001.354-.011c.213-.089.407-.217.569-.378l5.364-5.168 5.365 5.168a1.808 1.808 0 002.5.02c.165-.16.297-.35.386-.56a1.65 1.65 0 00-.012-1.319l-.183.082.183-.082a1.699 1.699 0 00-.394-.55z",
  fill: "#000",
  stroke: "#000",
  strokeWidth: ".4"
}));